import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex--gap-medium form__input-wrapper" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["for"]
const _hoisted_5 = ["id"]
const _hoisted_6 = ["for"]
const _hoisted_7 = ["id"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: "invisible",
      for: $props.inputId + '-day'
    }, " Day ", 8 /* PROPS */, _hoisted_2),
    _withDirectives(_createElementVNode("input", {
      id: $props.inputId + '-day',
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.day) = $event)),
      type: "text",
      pattern: "[0-9]*",
      inputmode: "numeric",
      class: _normalizeClass(["form__input form__input--med form__input--simple-number", $props.error ? 'form__input--error' : '']),
      onInput: $setup.emitUpdated,
      onKeyup: $setup.nextDateInput
    }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_3), [
      [_vModelText, $setup.day]
    ]),
    _createElementVNode("label", {
      class: "invisible",
      for: $props.inputId + '-month'
    }, " Month ", 8 /* PROPS */, _hoisted_4),
    _withDirectives(_createElementVNode("input", {
      id: $props.inputId + '-month',
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.month) = $event)),
      type: "text",
      pattern: "[0-9]*",
      inputmode: "numeric",
      class: _normalizeClass(["form__input form__input--med form__input--simple-number", $props.error ? 'form__input--error' : '']),
      onInput: $setup.emitUpdated,
      onKeyup: $setup.nextDateInput
    }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_5), [
      [_vModelText, $setup.month]
    ]),
    _createElementVNode("label", {
      class: "invisible",
      for: $props.inputId + '-year'
    }, " Year ", 8 /* PROPS */, _hoisted_6),
    _withDirectives(_createElementVNode("input", {
      id: $props.inputId + '-year',
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.year) = $event)),
      type: "text",
      pattern: "[0-9]*",
      inputmode: "numeric",
      class: _normalizeClass(["form__input form__input--med form__input--simple-number", $props.error ? 'form__input--error' : '']),
      onInput: $setup.emitUpdated
    }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_7), [
      [_vModelText, $setup.year]
    ])
  ]))
}